var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    fillRule: "evenodd",
    d: "M.833 6.918c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v10.166c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25zm3.334.416H2.5v9.334h1.667zM14.167 10.084c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v7c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25zm3.333.417h-1.667v6.166H17.5zM7.5 2.917c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V17.08c0 .69-.56 1.25-1.25 1.25h-2.5c-.69 0-1.25-.56-1.25-1.25zm3.333.417H9.167v13.33h1.666z",
    clipRule: "evenodd"
  })));
};
export default SvgBarChart;